//请自行添加语言资源
const TransportPlanFetchLog = {
  instructionNo: '指令编号',
  planNo: '运输计划单号',
  outPlanNo: '外部计划单号',
  customerOrderNo: '客户订单号',
  shipperName: '货主',
  trackingFrequency: '抓取频率',
  fetchFromTime: '抓取开始时间',
  fetchToTime: '抓取结束时间',
  fetchType: '抓取类型',
  outPlanNoRelatedStatus: '外部单号关联状态',
  dispatchTime: '发运时间',
  deliverTime: '送达时间',
  status: '指令状态',
  truckNo: '车牌号',
  plateColor: '车牌颜色',
  executeTime: '最后一次执行时间',
  executeResult: '最后一次执行结果',
  executeCount: '执行次数',
  instructionBatchNo: '抓取批次号',
  queryStatus: '抓取状态',
  queryResult: '抓取结果',
  startTime: '执行开始时间',
  endTime: '执行结束时间',
  totalNum: '抓取总条数',
  serialNo: '流水号',
  trackTime: '跟踪时间',
  trackType: '跟踪类型',
  location: '跟踪位置',
  dealStatus: '同步状态',
  dealCount: '同步次数',
  dealTime: '同步时间',
  dealResult: '同步结果',
  userNo: '用户编号',
  longitude: '经度',
  latitude: '纬度',
  accuracy: '定位精度',
  speed: '速度',
  altitude: '海拔',
  gpsTime: 'GPS定位时间',
  provider: '定位来源',
  locationProvince: '省',
  locationCity: '市',
  locationDistrict: '区',
  locationAddress: '地址',
  createTime: '创建时间',
  creator: '创建人',
  wxDealStatus: '处理状态',
  reverseGeocodingDealStatusName: '逆向地址处理状态',
  reverseGeocodingDealResult: '逆向地址处理结果',
  reverseGeocodingDealTime: '逆向地址处理时间',
  gpsFetchSource:'GPS采用渠道',
  deliverStatus:'送达状态',
  switchStatus: '切换小程序GPS状态',
  switchResult:'切换小程序GPS结果',
  switchExecuteTime:'执行切换小程序GPS时间',
};
export default TransportPlanFetchLog



// WEBPACK FOOTER //
// ./src/page/log/TransportPlanFetchLog/lang/TransportPlanFetchLog.zh.js